import React from "react";
import PropTypes from "prop-types";
import { IconButton, Tooltip } from "@mui/material";

// Icon button that disables itself and swaps its tooltip to explain why when
// the caller lacks the required permission, per the "hide or disable actions
// the admin can't perform, with a tooltip explaining the required permission" rule.
const PermissionIconButton = ({
  hasPermission,
  permissionLabel,
  tooltip,
  icon,
  onClick,
  ariaLabel,
  color = "#6b7280",
  size = "small",
}) => (
  <Tooltip title={hasPermission ? tooltip : `Requires ${permissionLabel} permission`}>
    <span>
      <IconButton
        size={size}
        onClick={onClick}
        disabled={!hasPermission}
        aria-label={ariaLabel}
        sx={{ color }}
      >
        {icon}
      </IconButton>
    </span>
  </Tooltip>
);

PermissionIconButton.propTypes = {
  hasPermission: PropTypes.bool.isRequired,
  permissionLabel: PropTypes.string.isRequired,
  tooltip: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  ariaLabel: PropTypes.string.isRequired,
  color: PropTypes.string,
  size: PropTypes.oneOf(["small", "medium"]),
};

export default PermissionIconButton;
